export default __webpack_public_path__ + "static/media/techbud_final_small.b8d2ca73.png";